<script lang="ts" setup>


const {findAllCategories} = useCategory()
const {data: separatedCategories, refresh} = await useAsyncData(
    `find_all_categories`,
    async () => {
      const allCategories = await findAllCategories();
      return {
        header: allCategories ? allCategories.slice(0, 5) : [],
        seeMore: allCategories ? allCategories.slice(5) : [],
      };
    },
    {default: () => ({header: [], seeMore: []})}
);
const headerCategories = computed(() => separatedCategories.value?.header)
const seeMore = computed(() => separatedCategories.value?.seeMore)
</script>
<template>
  <section class="container category pt-3">
    <h2 class="h3 mb-3">Categorias</h2>
    <div class="row row-cols-lg-6 row-cols-sm-3 row-cols-2 g-3 g-xl-4">
      <div class="col" v-for="(item, key) in headerCategories" :key="key">
        <nuxt-link class="icon-box card card-body h-100 border-0 shadow-sm card-hover h-100 text-center"
                   :to="`/eventos/categorias/${item.slug}`">
          <div class="icon-box-media bg-faded-primary text-primary rounded-circle mb-3 mx-auto">
            <Icon :icon="item.icon"/>
          </div>
          <h3 class="icon-box-title fs-base mb-0">{{ item.description }}</h3>
        </nuxt-link>
      </div>

      <div class="col">
        <div class="dropdown h-100">
          <a class="icon-box card card-body h-100 border-0 shadow-sm card-hover text-center" href="javascript:void(0);"
             data-bs-toggle="dropdown">
            <div class="icon-box-media bg-faded-primary text-primary rounded-circle mb-3 mx-auto">
              <i class="fi-dots-horisontal"></i>
            </div>
            <h3 class="icon-box-title fs-base mb-0">Mais</h3>
          </a>
          <div class="dropdown-menu dropdown-menu-end my-1">
            <nuxt-link v-for="(item, key) in seeMore" :key="key" class="dropdown-item fw-bold"
                       :to="`/eventos/categorias/${item.slug}`">
              <Icon :icon="item.icon" class="text-danger"/>
              {{ item.description }}
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
